import { allDocuments } from './documentConfigs';

export const getInitialDocumentStates = () =>
  allDocuments.reduce((acc, doc) => {
    acc[doc.key] = false;
    return acc;
  }, {});